'use client';
import MuiTextField, { TextFieldProps } from '@mui/material/TextField';

interface CustomTextFieldProps {
  error?: boolean;
  verified?: boolean;
}

export const TextField = (props: TextFieldProps & CustomTextFieldProps) => <MuiTextField {...props} />;
